import * as bootstrap from 'bootstrap';

// Optional: expose Bootstrap globally if needed (e.g. for inline scripts)
window.bootstrap = bootstrap;

export default bootstrap;
